module.exports = __webpack_public_path__ + "media/assets/img/devise/auth/auth_img-93192926e0f983a9c1dd5c273f6f1922.svg";